import { render, staticRenderFns } from "./Events3.vue?vue&type=template&id=c2670778&scoped=true&"
import script from "./Events3.vue?vue&type=script&lang=js&"
export * from "./Events3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2670778",
  null
  
)

export default component.exports